.button {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    align-self: flex-start;
    gap: 8px;
    height: 32px;
    padding: 0 8px;
    border: 1px solid transparent;
    border-radius: 1000px;
    background-color: var(--colorSurfacePrimary);
    color: var(--colorTextPrimary);
    font-family: var(--fontFamilySansRegular), sans-serif;
    font-size: 14px;
    line-height: 1.25;
    cursor: pointer;
    outline: none;
}

.button[data-hovered] {
    background-color: var(--colorSurfacePrimaryHover);
}

.button[data-pressed] {
    background-color: var(--colorSurfacePrimaryPress);
}

.button[data-focus-visible] {
    border-color: var(--colorBorderAccent);
    box-shadow: inset 0 0 0 1px var(--colorButtonSecondary);
    background-color: var(--colorSurfacePrimaryHover);
}

.button[data-disabled] {
    color: var(--colorTextDisabled);
    cursor: default;
}

.iconOnly {
    width: 32px;
    padding: 0;
    justify-content: center;
}